import { BrandMark } from './BrandMark';

// Collapsed sidebar: icon-only badge. See BrandMark.tsx for why this now
// renders the icon on a small dark chip rather than the bare PNG.
export const LogoIcon = () => <BrandMark size={40} />;
